import { render } from "./TipTapTextArea.vue?vue&type=template&id=c1898c3a&scoped=true"
import script from "./TipTapTextArea.vue?vue&type=script&lang=ts"
export * from "./TipTapTextArea.vue?vue&type=script&lang=ts"

import "./TipTapTextArea.vue?vue&type=style&index=0&id=c1898c3a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1898c3a"

export default script